import { FinancialStatisticsComponent } from '@app/components/FinancialStatisticsComponent/FinancialStatisticsComponent.main';

export { FinancialStatisticsComponent };
